<script>
	export let colorCircle = '#000'
	export let colorArrow = '#fff'
	export let angle = 0
	export let size = 12

	const angleMax = 75

	let realAngle = Math.max(-angleMax, Math.min(angleMax, -angle))
</script>

<div
	class="arrow"
	style="transform: rotate({realAngle}deg); width: {size}px; height: {size}px">
	<svg width={size} height={size} viewBox="-0.2 -0.2 10.4 10.4">
		<g transform="rotate(29.9 5 5)">
			<circle
				transform="rotate(330)"
				r="5"
				cy="6.8"
				cx="1.8"
				fill={colorCircle} />
			<path
				d="M2.4 6.6l5.2-3M4.5 2.5l3.4.9L7 6.8"
				stroke={colorArrow}
				stroke-linecap="square"
				stroke-linejoin="round" />
		</g>
	</svg>
</div>

<style lang="scss">
	.arrow {
		display: inline-block;
		top: 1px;
		position: relative;
		transform-origin: center center;
		vertical-align: baseline;
	}

	.arrow svg {
		display: block;
	}
	.arrow path {
		fill: none;
	}
</style>
